import React from 'react';
import API from '@zillow/mortgage-api-client';
import { useCurrentRatesButtonUrl } from './useCurrentRatesButtonUrl.js';
import { FieldConfig } from './ClosingCostCalculator.utils.js';
import TextField from '../Fields/TextField.js';
import { Paragraph } from '@zillow/constellation';

var InterestRate = function InterestRate(_ref) {
  var homePrice = _ref.homePrice,
    downPayment = _ref.downPayment;
  var currentRatesButtonUrl = useCurrentRatesButtonUrl('mortgage-rates', {
    value: homePrice,
    down: downPayment,
    auto: true,
    zip: API.zipcode && API.zipcode.length === 5 ? API.zipcode : null,
    source: 'Z_Mortgage_Calc_rates'
  });
  return /*#__PURE__*/React.createElement(TextField, {
    label: "Interest rate",
    rightAdornment: "%",
    name: FieldConfig.interestRate.name,
    config: FieldConfig.interestRate.config,
    textButtonName: "See current rates",
    textButtonHref: currentRatesButtonUrl,
    autoComplete: "off",
    tooltip: {
      title: 'Interest rate',
      body: /*#__PURE__*/React.createElement(Paragraph, null, "Representative interest rates are based upon a national, or state-specific average from lenders quoting on Zillow for preliminary research purposes only. Actual available rates and monthly payment amounts are subject to market fluctuations and will depend on a number of factors, including geography and loan characteristics.")
    },
    required: true
  });
};
var InterestRateField = InterestRate;

export { InterestRateField as default };
